import { React, useState, useEffect, useReducer } from 'react'
import { HashLink as Link } from 'react-router-hash-link';
import { motion, useAnimation } from "framer-motion";
import { useParams, } from "react-router-dom";
import joi from 'joi';
import { Helmet } from 'react-helmet'
import Cookies from 'universal-cookie'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faPhone, faGlobe, faBuilding, faList, faScaleBalanced, faCalendarPlus, faCalendarDays, faChampagneGlasses, faUsers, faCircleInfo, faHandHoldingHeart, faListCheck, faArrowRight } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'

import { lP, oP, sT, boxvar1, boxvar2, boxvar3, boxvar2_1, boxvar2_2, boxvar2_3, boxvar4, capFirstChar, formatDateWithTime, URL_MAINAPI, API_TOKEN } from '../../../main.js'

import '../../../main.css'
import './EventOverview.css'
import './MEventOverview.css'

import logo_mainbyton from '../../../assets/pictures/logos/4Helferzeit-Logo2x.webp'
import m_logo_mainbyton from '../../../assets/pictures/logos/1Helferzeit-Logo2x.webp'
import img_not_found from '../../../assets/pictures/imgnotfound.webp'


export default function EventOverview() {

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    const { eventid } = useParams();
    var [eventFound, setEventFound] = useState(1)

    var [eventRegistered, setEventRegistered] = useState(0)
    var [eventScheduleRegistered, setEventScheduleRegistered] = useState(0)

    var [formData, setFormData] = useState({
        formVorname: "",
        formNachname: ""
    })

    var [eventData, setEventData] = useState({
        eventId: "",
        eventOrgId: "",
        eventName: "",
        eventLongName: "Event wird geladen...",
        eventLogo: img_not_found,
        eventHeroImg: img_not_found,
        eventURL: "#",
        eventOrganizator: "unbekannt",
        eventContactURL: "#",
        eventImprintURL: "#",
        eventContactMail: "",
        eventContactTel: "",
        eventSlogan: "Mach mit!",
        eventApplicationActive: false,
        eventDates: {
            dateStart: "",
            dateEnd: "",
            applicationStart: "",
            applicationEnd: ""
        },
        eventCustomStyle: 0,
        eventStyle: {
            colorPrimary: '#662773',
            colorPrimaryGradient: '#986da0',
            colorSecondary: '#94b654',
            colorTileBg: '#f6deff',
            colorStdText: '#000000',
            colorBtnText: '#ffffff',
            colorStdTextOnTile: '#000000'
        },
        eventInfo: {
            box1Header: "Was ist das",
            box1Text: "Eventbeschreibung wird geladen...",
            box1HeroImg: null,
            box2Header: "Deine Aufgaben",
            box2Text1: "Aufgabenbeschreibung wird geladen...",
            box2Text2: "",
            box2CtaText: "Registrieren",
            box3Header: "Eckdaten",
            box3Contents: "",
            box3LookingFor: "",
            box3Text: "Weitere Fragen an den Veranstalter?",
            box3CtaText: "Kontakt"
        }
    })

    var [formError, setFormError] = useState(false)


    useEffect(() => {
        if (eventid == "0" || eventid == null) { } else {
            getEventData()
            getEventRegistered()
        }

        const listener = event => {
            if (event.code === "Enter" || event.code === "NumpadEnter") {
                document.querySelector('.regbtn').click();
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
        }
    }, [])

    function doEventAttend() {
        try {
            fetch(URL_MAINAPI + "/user/attend/" + eventid, {
                method: "PATCH",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    lP('/eventregisterschedule/' + eventid)
                } else {
                    setEventFound(0)
                    console.log(res.data);
                }
            }))
        } catch (err) {
        }
    }

    function getEventData() {
        try {
            fetch(URL_MAINAPI + "/event/" + eventid, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setEventFound(1)
                    applyEventData(res.data);
                } else {
                    setEventFound(0)
                    console.log(res.data);
                }
            }))
        } catch (err) {
            setEventFound(0)
        }
    }

    function getEventRegistered() {
        try {
            fetch(URL_MAINAPI + "/user/attend/" + eventid, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setEventRegistered(res.data.eventregistered ? 1 : 0)
                    setEventScheduleRegistered(res.data.eventscheduleregistered ? 1 : 0)
                } else {
                    setEventRegistered(0)
                    setEventScheduleRegistered(0)
                }
            }))
        } catch (err) {
            setEventRegistered(0)
            setEventScheduleRegistered(0)
        }
    }

    function applyEventData(metadata) {
        setEventData({
            eventId: metadata._id,
            eventOrgId: (metadata.organization && metadata.organization._id) ? String(metadata.organization._id) : (metadata.orgid ? String(metadata.orgid) : ""),
            eventName: metadata.name,
            eventLongName: metadata.longname,
            eventLogo: metadata.logo_img,
            eventHeroImg: metadata.hero_img,
            eventURL: metadata.url,
            eventOrganizator: metadata.organization.name,
            eventContactURL: metadata.organization.contact.url,
            eventImprintURL: metadata.organization.contact.imprint_url,
            eventContactMail: metadata.organization.contact.email,
            eventContactTel: metadata.organization.contact.tel,
            eventSlogan: metadata.slogan,
            eventApplicationActive: metadata.applicationActive,
            eventDates: {
                dateStart: metadata.dates.dateStart,
                dateEnd: metadata.dates.dateEnd,
                applicationStart: metadata.dates.applicationStart,
                applicationEnd: metadata.dates.applicationEnd
            },
            eventCustomStyle: metadata.customstyle,
            eventStyle: {
                colorPrimary: metadata.style.colorPrimary,
                colorPrimaryGradient: metadata.style.colorPrimaryGradient,
                colorSecondary: metadata.style.colorSecondary,
                colorTileBg: metadata.style.colorTileBg,
                colorStdText: metadata.style.colorStdText,
                colorBtnText: metadata.style.colorBtnText,
                colorStdTextOnTile: metadata.style.colorStdTextOnTile
            },
            eventInfo: {
                box1Header: metadata.info.box1Header,
                box1Text: metadata.info.box1Text,
                box1HeroImg: metadata.info.box1HeroImg,
                box2Header: metadata.info.box2Header,
                box2Text1: metadata.info.box2Text1,
                box2Text2: metadata.info.box2Text2,
                box2CtaText: metadata.info.box2CtaText,
                box3Header: metadata.info.box3Header,
                box3Contents: metadata.info.box3Contents,
                box3LookingFor: metadata.info.box3LookingFor,
                box3Text: metadata.info.box3Text,
                box3CtaText: metadata.info.box3CtaText
            }
        });

        if (metadata.customstyle) {
            document.documentElement.style.setProperty('--event_color_primary', metadata.style.colorPrimary);
            document.documentElement.style.setProperty('--event_color_primarygradient', metadata.style.colorPrimaryGradient);
            document.documentElement.style.setProperty('--event_color_secondary', metadata.style.colorSecondary);
            document.documentElement.style.setProperty('--event_color_tilebg', metadata.style.colorTileBg);
            document.documentElement.style.setProperty('--event_color_stdtext', metadata.style.colorStdText);
            document.documentElement.style.setProperty('--event_color_stdtextontile', metadata.style.colorStdTextOnTile);
            document.documentElement.style.setProperty('--event_color_btntext', metadata.style.colorBtnText);
        }
    }

    function startRegister() {
        let valresult;
        valresult = joi.object({
            "firstname": joi.string().trim().min(2).max(20).pattern(/^[A-Za-z\-.À-ÿ\s]*$/).required(),
            "lastname": joi.string().trim().min(2).max(20).pattern(/^[A-Za-z\-.À-ÿ\s]*$/).required(),
        }).validate({ firstname: formData.formVorname, lastname: formData.formNachname });
        console.log(valresult.error);
        if (valresult.error != null | formData.formVorname == "" | formData.formNachname == "" | formData.formVorname.length < 2 | formData.formNachname.length < 2) {
            setFormError(true);
        } else {
            setFormError(false);
            lP("/eventregister/" + eventid + "?formVorname=" + encodeURIComponent(formData.formVorname) + "&formNachname=" + encodeURIComponent(formData.formNachname));
        }
    }

    /* --- Error State: Event nicht gefunden --- */
    if (eventid == "0" || eventid == null || eventFound == 0) {
        return (
            <div className='mainCon page' id='mainCon'>
                <MainHeader selectedsite={""} />
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Eventübersicht</title>
                    <meta name="robots" content="noindex" />
                </Helmet>

                <main className='page-body container section'>
                    <div className='card' style={{ padding: '40px', textAlign: 'center', maxWidth: '600px', margin: '40px auto' }}>
                        <h2 style={{ color: 'var(--text)' }}>Das gesuchte Event wurde nicht gefunden!</h2>
                        <p style={{ color: 'var(--text-secondary)' }}>Bitte kehre zur vorigen Seite zurück. Oder versuche den Veranstalter zu kontaktieren.</p>
                        <CTAButton variant="primary" title={"Startseite"} onclick={() => lP('/')} />
                    </div>
                </main>

                <MainFooter useEventStyle={false} />
            </div>
        );
    }

    /* --- Application Phase Badge --- */
    let appPhaseBadge = null;
    if (eventData.eventDates.applicationStart && eventData.eventDates.applicationEnd) {
        const now = Date.now();
        const appStart = new Date(eventData.eventDates.applicationStart).getTime();
        const appEnd = new Date(eventData.eventDates.applicationEnd).getTime();
        if (eventData.eventApplicationActive && now <= appEnd && now >= appStart) {
            appPhaseBadge = <span className="badge badge-open"><FontAwesomeIcon icon={faCalendarDays} /> Anmeldung läuft</span>;
        } else if (now < appStart) {
            appPhaseBadge = <span className="badge badge-upcoming"><FontAwesomeIcon icon={faCalendarPlus} /> Anmeldung zukünftig</span>;
        } else {
            appPhaseBadge = <span className="badge badge-closed"><FontAwesomeIcon icon={faCalendarDays} /> Anmeldung beendet</span>;
        }
    }

    return (
        <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Event: {eventData.eventName}</title>
                <meta property="og:title" content={"Helferzeit-Event: " + eventData.eventName} />
                <meta property="og:description" content={"Erfahre mehr über die Veranstaltung auf Helferzeit: " + eventData.eventLongName + ". Entdecke alle Infos, registriere dich und helfe mit."} />
            </Helmet>

            {/* Event-Leiste: ersetzt die alte Titlebar */}
            <div className='eventbar'>
                <div className='eventbar-inner'>
                    <motion.img
                        variants={boxvar4}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, margin: "-50px" }}
                        alt='Logo des Veranstalters bzw. der Organisation'
                        className='eventbar-logo'
                        src={eventData.eventLogo}
                        onClick={() => oP(eventData.eventURL)}
                    />
                    <motion.h2
                        variants={boxvar4}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false, margin: "-50px" }}
                        className='eventbar-name'
                        onClick={() => lP('/event/' + eventid)}
                        style={{ cursor: "pointer" }}
                    >
                        {eventData.eventName == "" ? <Skeleton height={22} width="60%" /> : eventData.eventLongName}
                    </motion.h2>
                    {appPhaseBadge}
                </div>
            </div>

            <main className='page-body'>
                {/* Hero + Registrierung */}
                <section className='container section' style={{ paddingTop: '40px' }}>
                    <div className='hero-grid'>
                        <div className='hero-text'>
                            <motion.h1
                                variants={boxvar3}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: false, margin: "-50px" }}
                            >
                                {eventData.eventSlogan}
                            </motion.h1>
                            <motion.div
                                variants={boxvar1}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: false, margin: "-50px" }}
                                className='hero-img-wrap'
                            >
                                <img
                                    alt='Illustration'
                                    className='hero-img'
                                    src={eventData.eventHeroImg}
                                />
                            </motion.div>
                        </div>

                        <motion.div
                            variants={boxvar2_1}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, margin: "-50px" }}
                            className='register-col'
                        >
                            <div className='card register-card' id="eventregister">
                                {(loggedin == 1) ? <h3>Willkommen zurück, {cur_firstname} {cur_lastname}!</h3> :
                                    (formData.formVorname != "") ? <h3>Hey {formData.formVorname}, bist du das erste Mal dabei?</h3> : <h3>Hey, bist du das erste Mal dabei?</h3>}

                                {(!loggedin && !eventData.eventApplicationActive) ? (
                                    <p><b>Die Registrierungsphase ist nicht aktiv. Die Daten zum Anmeldezeitraum findest du unten.</b></p>
                                ) : null}

                                {(!loggedin && eventData.eventApplicationActive) ? (
                                    <form>
                                        <div className="field">
                                            <label htmlFor="reg-vorname">Dein Vorname</label>
                                            <input
                                                id="reg-vorname"
                                                type="text"
                                                pattern="\w{2,30}"
                                                maxLength="30"
                                                minLength="2"
                                                className="in_vorname"
                                                name="vorname"
                                                placeholder="Vorname"
                                                autoFocus
                                                value={formData.formVorname}
                                                autoComplete='given-name'
                                                onInput={(e) => { setFormData({ ...formData, formVorname: capFirstChar(e.target.value) }); setFormError(false); }}
                                            />
                                        </div>
                                        <div className="field">
                                            <label htmlFor="reg-nachname">Dein Nachname</label>
                                            <input
                                                id="reg-nachname"
                                                type="text"
                                                pattern="\w{2,30}"
                                                maxLength="30"
                                                minLength="2"
                                                className="in_nachname"
                                                name="nachname"
                                                placeholder="Nachname"
                                                value={formData.formNachname}
                                                autoComplete='family-name'
                                                onInput={(e) => { setFormData({ ...formData, formNachname: capFirstChar(e.target.value) }); setFormError(false); }}
                                            />
                                        </div>
                                        {(formError) ? <span className="error-msg"><FontAwesomeIcon icon={faCircleInfo} /> Bitte fülle alle Pflichtfelder korrekt aus.</span> : null}
                                        <CTAButton variant="primary" block={true} hideArrow={true} className="regbtn action_first_btn" title={"Registrieren"} onclick={() => startRegister()} />
                                    </form>
                                ) : null}

                                {/* Logged-in states */}
                                {(loggedin && !eventRegistered && !eventData.eventApplicationActive) ? (
                                    <div>
                                        <p>Du bist noch nicht bei diesem Event dabei und die Registrierungsphase ist nicht aktiv.</p>
                                        <CTAButton variant="secondary" block={true} className="action_scnd_btn" title={"Profil"} onclick={() => lP('/profil')} />
                                    </div>
                                ) : (loggedin && !eventRegistered && eventData.eventApplicationActive) ? (
                                    <div>
                                        <p>Du bist noch nicht bei diesem Event dabei. Jetzt ändern!</p>
                                        <CTAButton variant="primary" block={true} className="action_first_btn" title={"Mitmachen"} onclick={() => doEventAttend()} />
                                        <CTAButton variant="secondary" block={true} className="action_scnd_btn" title={"Profil"} onclick={() => lP('/profil')} />
                                    </div>
                                ) : (loggedin && eventRegistered && !eventScheduleRegistered) ? (
                                    <div>
                                        <p>Du musst noch deine Wunschdienste für dieses Event auswählen, um teilnehmen zu können. Hole das hier nach:</p>
                                        <CTAButton variant="primary" block={true} className="action_first_btn" title={"Zur Dienstplanung"} onclick={() => lP('/eventregisterschedule/' + eventid)} />
                                        <br />
                                        <p>Falls du vom Veranstalter manuell hinzugefügt wurdest, kannst du hier vorab deinen Dienstplan einsehen</p>
                                        <CTAButton variant="primary" block={true} className="action_first_btn" title={"Mein Dienstplan"} onclick={() => lP('/eventplannedschedule/' + eventid)} />
                                        <CTAButton variant="secondary" block={true} className="action_scnd_btn" title={"Nachrichten"} onclick={() => lP('/profil/messages/' + eventid)} />
                                        <CTAButton variant="secondary" block={true} className="action_scnd_btn" title={"Profil"} onclick={() => lP('/profil')} />
                                    </div>
                                ) : (loggedin && eventRegistered && eventScheduleRegistered) ? (
                                    <div>
                                        <p>Vielen Dank! Du bist bereits für dieses Event registriert.</p>
                                        <CTAButton variant="primary" block={true} className="action_first_btn" title={"Eingereichte Dienste"} onclick={() => lP('/eventregisteredschedule/' + eventid)} />
                                        <CTAButton variant="primary" block={true} className="action_first_btn" title={"Mein Dienstplan"} onclick={() => lP('/eventplannedschedule/' + eventid)} />
                                        <CTAButton variant="secondary" block={true} className="action_scnd_btn" title={"Nachrichten"} onclick={() => lP('/profil/messages/' + eventid)} />
                                        <CTAButton variant="secondary" block={true} className="action_scnd_btn" title={"Profil"} onclick={() => lP('/profil')} />
                                    </div>
                                ) : null}

                                {/* Login-Link für nicht eingeloggte Nutzer */}
                                {(!loggedin) ? (
                                    <>
                                        <div className="login-divider">Schon ein Konto?</div>
                                        <CTAButton variant="secondary" block={true} className="action_scnd_btn" title={"Anmelden"} onclick={() => lP('/login?eventid=' + eventid + '&formVorname=' + formData.formVorname + '&formNachname=' + formData.formNachname)} />
                                    </>
                                ) : null}
                            </div>
                        </motion.div>
                    </div>
                </section>

                {/* Info-Boxen: Was ist das / Deine Aufgaben / Eckdaten */}
                <section className='container section' style={{ paddingTop: '8px' }}>
                    <div className='grid grid-3'>
                        {/* Box 1: Was ist das? */}
                        <motion.div variants={boxvar2_1} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card info-card'>
                                <h2><FontAwesomeIcon icon={faCircleInfo} style={{ color: 'var(--info)' }} /> {eventData.eventInfo.box1Header}</h2>
                                {(eventData.eventInfo.box1HeroImg != null && eventData.eventInfo.box1HeroImg != "") ? (
                                    <img alt='Demonstratives Bild' className='info-card-heroimg' src={eventData.eventInfo.box1HeroImg} />
                                ) : null}
                                <p dangerouslySetInnerHTML={{ __html: eventData.eventInfo.box1Text }} />
                            </div>
                        </motion.div>

                        {/* Box 2: Deine Aufgaben */}
                        <motion.div variants={boxvar2_2} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card info-card'>
                                <h2><FontAwesomeIcon icon={faHandHoldingHeart} /> {eventData.eventInfo.box2Header}</h2>
                                <p dangerouslySetInnerHTML={{ __html: eventData.eventInfo.box2Text1 }} />
                                <Link smooth to='#eventregister'>
                                    <CTAButton variant="secondary" className="action_scnd_btn" title={eventData.eventInfo.box2CtaText} onclick={() => { }} />
                                </Link>
                                <p dangerouslySetInnerHTML={{ __html: eventData.eventInfo.box2Text2 }} />
                            </div>
                        </motion.div>

                        {/* Box 3: Eckdaten */}
                        <motion.div variants={boxvar2_3} initial="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card info-card'>
                                <h2><FontAwesomeIcon icon={faListCheck} /> {eventData.eventInfo.box3Header}</h2>
                                <div className="kv-list">
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarPlus} /><b>Anmeldezeitraum</b> {formatDateWithTime(new Date(eventData.eventDates.applicationStart))} – {formatDateWithTime(new Date(eventData.eventDates.applicationEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarDays} /><b>Veranstaltung</b> {formatDateWithTime(new Date(eventData.eventDates.dateStart))} – {formatDateWithTime(new Date(eventData.eventDates.dateEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faChampagneGlasses} /><b>Inhalte</b> {eventData.eventInfo.box3Contents}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faUsers} /><b>Benötigte Helfer</b> {eventData.eventInfo.box3LookingFor}</div>
                                </div>
                                <p dangerouslySetInnerHTML={{ __html: eventData.eventInfo.box3Text }} />

                                <div className="contact-list">
                                    {(eventData.eventContactMail != "") ? (
                                        <a href={"mailto:" + eventData.eventContactMail}><FontAwesomeIcon icon={faEnvelope} /> {eventData.eventContactMail}</a>
                                    ) : null}
                                    {(eventData.eventContactTel != "") ? (
                                        <a href={"tel:" + eventData.eventContactTel}><FontAwesomeIcon icon={faPhone} /> {eventData.eventContactTel}</a>
                                    ) : null}
                                    <a href={eventData.eventURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faGlobe} /> Webseite des Veranstalters</a>
                                    <a href={eventData.eventImprintURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faScaleBalanced} /> Impressum des Veranstalters</a>
                                    <a><FontAwesomeIcon icon={faBuilding} /> Veranstalter: {eventData.eventOrganizator}</a>
                                    {(eventData.eventOrgId) ? (
                                        <a href={'/events/public/' + eventData.eventOrgId} onClick={(e) => { e.preventDefault(); lP('/events/public/' + eventData.eventOrgId); }}>
                                            <FontAwesomeIcon icon={faList} /> Weitere öffentliche Events dieser Organisation
                                        </a>
                                    ) : null}
                                </div>
                                <CTAButton variant="secondary" size="sm" className="action_scnd_btn" title={eventData.eventInfo.box3CtaText} onclick={() => oP(eventData.eventContactURL)} />
                            </div>
                        </motion.div>
                    </div>
                </section>
            </main>

            <MainFooter useEventStyle={true} />
        </div>
    )
}
